<template>
  <div class="article-editor-wrapper">
    <!-- 文章标题 -->
    <el-form :model="form" label-width="80px" size="medium">
      <el-form-item label="文章标题：">
        <el-input
          v-model="form.text"
          placeholder="请输入文章标题"
          clearable
          @input="handleTitleChange"
        />
      </el-form-item>

      <!-- 文章详情（富文本编辑器） -->
      <el-form-item label="文章内容：">
        <div class="editor-container">
          <quill-editor
            v-model="form.descrption"
            ref="myQuillEditor"
            :options="editorOption"
            @blur="onEditorBlur($event)"
            @focus="onEditorFocus($event)"
            @change="onEditorChange($event)"
          />
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
// 引入富文本编辑器
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

export default {
  name: "CustomAddForm",
  components: {
    quillEditor,
  },
  props: {
    // 支持父组件传入初始值
    value: {
      type: Object,
      default: () => ({
        title: "",
        content: "",
      }),
    },
  },
  data() {
    return {
      form: {
        title: "",
        content: "",
      },
      // 富文本编辑器配置
      editorOption: {
        theme: "snow",
        modules: {
          toolbar: [
            ["undo", "redo"],
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
            ["link", "image", "video"],
            ["clean"],
          ],
        },
        placeholder: "请输入文章内容...",
      },
    };
  },
  watch: {
    // 监听父组件传入的value变化，同步到子组件表单
    value: {
      immediate: true,
      handler(val) {
        this.form = { ...val };
      },
    },
  },
  methods: {
    // 标题输入变化时通知父组件
    handleTitleChange() {
      this.$emit("input", this.form);
    },
    // 富文本编辑器事件
    onEditorBlur() {},
    onEditorFocus() {},
    onEditorChange() {
      this.$emit("input", this.form);
    },
    // 外部调用：获取表单数据
    getFormData() {
      return this.form;
    },
    // 外部调用：重置表单
    resetForm() {
      this.form = { title: "", content: "" };
      this.$emit("input", this.form);
    },
  },
};
</script>

<style scoped lang="scss">
.article-editor-wrapper {
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
}

.editor-container {
  height: 400px;
  display: flex;
  flex-direction: column;

  :deep(.ql-container) {
    flex: 1;
    overflow-y: auto;
  }

  :deep(.ql-editor) {
    min-height: 350px;
    font-size: 14px;
    font-family: "微软雅黑";
  }
}

:deep(.el-form-item__label) {
  font-weight: 500;
  color: #303133;
}
</style>
